export default "__VITE_ASSET__DyzUwDIq__"